"use client";
import Carousel from "@/components/molecules/CustomCarousels/Carousel";
import React, { useCallback, useRef, useState } from "react";
import styles from './ReviewSectionMbaLp.module.scss'
import clsx from "clsx";
import LeftArrowNoTail from "@/SvgIcons/LeftArrowNoTail";
import RightArrowNoTail from "@/SvgIcons/RightArrowNoTail";
import { IModalActions, ModalTypes } from "@/types/modal";
import { useModalDispatch } from "@/context/ModalContext";
import { mergeArrayAlternatively } from "@/helpers/mergeArrayAlternatively";
import { pushToDataLayer } from "@/helpers/gtag";
import cn from 'clsx';
import { addStaticSubdomain } from "@/revamp/molecules/ProgramCard/utils";
import { getYouTubeEmbedUrl } from "@/data/homepage-revamp-static-data";
import ClientSideButton from "@/revamp2/molecules/Carousels/HeroCarousel/ClientSideButton";
import { GAEvent } from "@/helpers/gaEvents";
import VideoSlideMba from "./VideoSlideMbaLp";

const ReviewsMbaLp = ({ associatedPrograms={},testimonialData=[],VideoTestimonials=[]}) => {
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const sliderRef = useRef(null);
  const modalDispatch = useModalDispatch();

  const { START_YOUR_STUDENT_STORY_TODAY } = GAEvent;

  const [currentVideoUrl, setCurrentVideoUrl] = useState<string | null>(null);

  const handleOpenModal = (link: string) => {
    setCurrentVideoUrl(link);
  };

  const handleCloseModal = () => {
    setCurrentVideoUrl(null);
  };
  const finalReviews = mergeArrayAlternatively(
    testimonialData.slice(0,3),
    VideoTestimonials
  );

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.prevSlide();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.nextSlide();
  }, []);

  const handleSlideChange = (swiper) => {
    setIsAtStart(swiper.isBeginning);
    setIsAtEnd(swiper.isEnd);
  };

  const handleTestimonial = ({ text, sent_by, rating }) => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.TestimonialModal,
        modalData: { text, sent_by, rating },
      },
    });
  };

  const handleGaClick = () => {
    setTimeout(() => {
      pushToDataLayer({
        cta_text: "FAST TRACK YOUR CAREER",
        page_type: "Home Page",
        page_url: window.location.href || "NA",
      });
    }, 1000)
  };

  const handlePlayClick = (videoUrl: string) => {
    handleOpenModal(videoUrl);
  };

  return (
    <>
    <div className={styles.reviewsMbaContainer} id="testimonials">
      <div className={styles.reviewsOnlineContainer}>
        <div className={styles.header_container}>
          <h2 className={styles.reviewsOnlineTitle} id="review-testimonial-heading">
            Real Stories. Real Journeys. Real Impact.
          </h2>
          <ClientSideButton
            modalType={ModalTypes.ConnectModalMba}
            sessionStateUpdate={{
            "parentSection": "Testimonial",
            leadStartingCta: "Start Your Success Story Today"
            }}
            GADataNew={{
              event: "lead_initiate",
              cta_text: "Start Your Success Story Today",
              section_name: "Testimonial",
              header_title: "NA",
              isPageType: true,
              page_url: true,
            }}
            modalData={{
              associatedPrograms,
              isLandingPage: false,
              modalVariant: "studentStory",
              rfiCase: "THANK_YOU_PAGE_CASE",
              isLambdaAPI: true
            }}
            styles={{ backgroundColor: "#1a325b",color:"white",borderRadius:"0.8rem", fontWeight: 600 }}
            className={styles.enquireNowBtn}
            ctaText={"Start Your Success Story Today"}
            id="start-your-student-story-today-btn"
          />
        </div>
        <hr />
        <div className={cn(styles.text_caru_container, "relative")}>
          <Carousel
            ref={sliderRef}
            config={{
              autoplay: { status: false },
              spaceBetween: 12,
              slidesPerView: 1.5,
              pagination: {
                status: false,
                className: `${styles.bulletsContainer} revamp_carousel_pagination`,
              },
              breakpoints: {
                320: {
                  slidesPerView: 2,
                  spaceBetween: 5,
                },
                438: {
                  slidesPerView: 2,
                  spaceBetween: 5,
                },
                460: {
                  slidesPerView: 1.5,
                  spaceBetween: 5,
                },
                490: {
                  slidesPerView: 1.7,
                  spaceBetween: 5,
                },
                550: {
                  slidesPerView: 2,
                  spaceBetween: 5,
                },
                640: {
                  slidesPerView: 2.2,
                  spaceBetween: 5,
                },
                710: {
                  slidesPerView: 2.5,
                  spaceBetween: 5,
                },
                805: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                890: {
                  slidesPerView: 3.5,
                  spaceBetween: 10,
                },
                1050: {
                  slidesPerView: 3.7,
                  spaceBetween: 5,
                },
                1087: {
                  slidesPerView: 4,
                  spaceBetween: 5,
                },
              },
              onSlideChange: ({ isBeginning, isEnd }) =>
                handleSlideChange({ isBeginning, isEnd }),
            }}
            className={`${styles.reviewsCarouselWrapper} relative`}
            slidesContainerClassName={styles.slidesContainer}
            slideWrapperClassName={styles.slideWrapper}
            isSmoothBehaviour={true}
            id="honest-review"
          >
            {finalReviews?.map((item, index) => {
              return (
                <div key={index} className={styles.reviewsOnlineItem}>
                  {
                    index % 2 === 0   ?
                      (
                        <div className={styles.textReviewContainer}>
                          <div className={styles.reviewContent}>
                            <div className={styles.reviewerImg}>
                              <img
                                src={
                                  addStaticSubdomain(item?.sent_by?.avatar ||
                                    "https://amityonline.com/_s/Pi7_Image_Cropper_1_9bcfd61426.webp")
                                }
                                alt={item?.sent_by?.name || `reviewer-${index + 1}`}
                                width={100}
                                height={100}
                              />
                            </div>
                            <div className={styles.reviewerDetails}>
                              <h3 className={styles.reviewerName}>
                                {item?.sent_by?.name || ""}
                              </h3>
                              <p className={styles.reviewerDegree}>
                                {item.sent_by?.title || ""}
                              </p>
                              <p className={styles.stars}>
                                {Array.from({ length: 5 }).map((_, i) => (
                                  <span key={i}>{i < item?.rating ? "★" : "☆"}</span>
                                ))}
                              </p>
                            </div>
                          </div>
                          <div className={styles.reviewBody}>
                            <p className={styles.reviewText}>{item?.text || ""}</p>
                          </div>
                          <button
                            className={styles.readMoreBtn}
                            onClick={() =>
                              handleTestimonial({
                                text: item?.text,
                                sent_by: item?.sent_by,
                                rating: item?.rating,
                              })
                            }
                            id={"read-full-testimonial-" + index}
                          >
                            Read More
                          </button>
                        </div>
                      )
                      : (
                        
                        <VideoSlideMba
                          index={index}
                          data={item}
                          handlePlayClick={handlePlayClick}
                        />
                      )
                  }
                </div>
              );
            })}
          </Carousel>
          <button
            className={clsx(styles.prevArrow)}
            onClick={handlePrev}
            disabled={isAtStart}
            aria-label="Previous"
            id="prev-btn"
          >
            <LeftArrowNoTail />
          </button>
          <button
            className={clsx(styles.nextArrow)}
            onClick={handleNext}
            aria-label="Next"
            disabled={isAtEnd}
            id="next-btn"
          >
            <RightArrowNoTail />
          </button>
        </div>
      </div>
      {
        currentVideoUrl && (
          <div
            onClick={handleCloseModal}
            className={styles.videoModalContainer}
          >
            <div className={styles.videoModalBox}>
              <div className={styles.closeButtonContainer}>
                <button
                  onClick={handleCloseModal}
                  className={styles.closeButton}
                >
                  ✕
                </button>
              </div>
              <div
                onClick={(e) => e.stopPropagation()}
                className={styles.videoModalContent}
              >
                <div className={styles.iframeContainer}>
                  {currentVideoUrl && (
                    <iframe
                      src={getYouTubeEmbedUrl(currentVideoUrl) + "?autoplay=1"}
                      title="youtube-modal-video"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        )
      }
    </div>

    </>
  );
};

export default ReviewsMbaLp;
